import BMXModal from "../../../../Components/Modals/BMXModal/BMXModal";
import { connectModal } from "redux-modal";
import { useState } from "react";
import BMXButton from "../../../../Components/Buttons/BMXButton/BMXButton";
import { useTranslation } from "react-i18next";
import ServiceStatusOfTodayForm from "../../Forms/ServiceStatusOfTodayForms/ServiceStatusOfTodayForm";

const ServiceStatusOfTodayModal = (props) => {
  const { t } = useTranslation();

  const [isSubmit, setIsSubmit] = useState(false);
  const formName = "ServiceStatusOfTodayForm";
  const { handleHide, show } = props;

  // const buttons = () => {
  //   return (
  //     <>
  //       <BMXButton
  //         data-cy="save"
  //         type="subbmit"
  //         onClick={() => setIsSubmit(true)}
  //         bmxclass="Success"
  //         form={formName}
  //       >
  //         {t("global:save")}
  //       </BMXButton>
  //     </>
  //   );
  // };

  return (
    <BMXModal
      open={show}
      width={"90%"}poł
      height={"750px"}
      onClose={handleHide}
      header={props.header}
      // buttons={buttons()}
    >
      <ServiceStatusOfTodayForm
        isSubmit={isSubmit}
        handleHide={handleHide}
        formName={formName}
        {...props}
      />
    </BMXModal>
  );
};

export default connectModal({ name: "ServiceStatusOfTodayModal" })(
  ServiceStatusOfTodayModal
);
